(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-quote"] && !Shopify.designMode) return;
  try {
    function initProductQuoteButtons(root = document) {
  const buttons = root.querySelectorAll("[data-quote-button-trigger]")

  buttons.forEach(button => {
    if (button.dataset.quoteButtonBound === 'true') return;
    button.dataset.quoteButtonBound = 'true';

    button.addEventListener('click', () => {
      console.log("Clicked")
    })
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initProductQuoteButtons();
  });
} else {
  initProductQuoteButtons();
}
  } catch(e) { console.error(e); }
})();

})();
